const removeAsterisk = (str) => {
  if (typeof str !== 'string') return str;
  return str.replace(/\*/g, '');
};

export default removeAsterisk;
